import "./style.css";
import Hero from "../../components/hero/hero";
import Services from "../../containers/services/services";
import PricingSection from "../../containers/pricing/PricingSection";
import WorkMethod from "../../containers/workMethod/workMethod";
import ProcessSteps from "../../containers/processSteps/processSteps";

// import Accueil from "../../containers/accueil/index.jsx";
const Home = () => {
  return (
    <div>
      <Hero />
    
      {/* <Accueil /> */}
      <Services />
      <PricingSection variant="compact" />
      <WorkMethod />
      <ProcessSteps />
    </div>
  );
};

export default Home;
